import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { TranslationPipe } from 'src/app/pipes/translation/translation-pipe';
import { AppButton } from '../button/app-button';

@Component({
  selector: 'app-confirmation-dialog',
  imports: [CommonModule, FormsModule, TranslationPipe, SelectModule, MultiSelectModule, AppButton],
  templateUrl: './confirmation-dialog.html',
  styleUrl: './confirmation-dialog.scss'
})
export class ConfirmationDialog {
  config = inject(DynamicDialogConfig);
  ref = inject(DynamicDialogRef);

  isLoading: boolean = false;
  editableTextValue: string = '';
  selectDropdownId: number = 0;
  multiselectDropdownIds: number[] = [];

  ngOnInit() {
    if (this.config.data.showCancel === false) {
      this.config.data.showCancel = false;
    } else {
      this.config.data.showCancel = true;
    }

    if (this.config.data.loading$) {
      this.config.data.loading$.subscribe((val: boolean) => {
        this.isLoading = val;
      });
    }
  }

  onPrimaryBtnClickEvent() {
    const data = this.config.data;
    let payload: any = true;

    if (data.editableTextarea) {
      payload = this.editableTextValue;
    } else if (data.selectDropdown) {
      payload = this.selectDropdownId;
    } else if (data.multiselectDropdown) {
      payload = this.multiselectDropdownIds;
    }

    data.event$.next(payload);
  }

  onCancel() {
    this.config.data.event$.next(false);
  }
}
